document.addEventListener('alpine:init', () => {
  Alpine.data('xFiltersAndSortby', (sectionId) => ({
    t: '',
    show: false,
    showFilterAside: true,
    loading: false,
    renderStatus: '',
    isDesktop: false,
    listLayout: false,
    cachedResults: {},
    filterOpener: null,
    renderController: null,
    renderSerial: 0,
    searchParamsPrev: window.location.search.slice(1),
    searchParamsInitial: window.location.search.slice(1),
    init() {
      if (localStorage.getItem("list-layout") == 'list') {
        this.listLayout = true;
      }
      this._initLayout();
      this._setListeners();
    },
    _initLayout() {
      let formAside = document.getElementsByClassName('form-aside')[0];
      let formDrawer = document.getElementsByClassName('form-drawer')[0];
      if (window.innerWidth > 767) {
        this.isDesktop = true;
        if (formAside) {
          formAside.setAttribute('id','FacetFiltersForm');
          if (formDrawer) formDrawer.removeAttribute('id');
        } else {
          if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
        }
      } else {
        this.isDesktop = false;
        if (formAside) formAside.removeAttribute('id');
        if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
      }
    },
    _setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
        if (searchParams === this.searchParamsPrev) return;
        this._renderPage(searchParams, false);
      }
      window.addEventListener('popstate', onHistoryChange);

      installMediaQueryWatcher('(min-width: 768px)', () => this._initLayout());
    },
    toggleLayout(theBoolean) {
      this.listLayout = theBoolean;
      localStorage.setItem("list-layout", theBoolean ? "list" : "grid" );
      window.dispatchEvent(new Event('resize'));
    },
    removeFilter(url) {
      return this._reloadFilter(url);
    },
    openFilter(opener) {
      this.filterOpener = opener instanceof HTMLElement ? opener : document.activeElement;
      this.show = true;
      Alpine.store('xPopup').openFor('filter');
      this.$nextTick(() => requestAnimationFrame(() => this._filterFocus()));
    },
    closeFilter(returnFocus = true) {
      if (!this.show) return;
      const opener = this.filterOpener;
      this.filterOpener = null;
      this.show = false;
      Alpine.store('xFocusElement').removeTrapFocus();
      Alpine.store('xPopup').closeFor('filter');
      if (returnFocus) requestAnimationFrame(() => opener?.isConnected && opener.focus({ preventScroll: true }));
    },
    async applyFilters() {
      clearTimeout(this.t);
      const form = document.getElementById('FacetFiltersForm');
      const searchParams = this._createSearchParams(form);
      const success = searchParams === this.searchParamsPrev && !this.loading
        ? true
        : await this._renderPage(searchParams);
      if (success) this.closeFilter();
    },
    renderPagination() {
      var formData = {
        'attributes': {
          'collection-pagination': this.$el.value             
        }
      }; 
      fetch(Shopify.routes.root+'cart/update', {
        method:'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(formData)
      }).then(() => {
        this.cachedResults = [];
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
      }); 
    },
    onSubmit(wait = 500) {
      clearTimeout(this.t);

      const func = () => {
        const form = document.getElementById('FacetFiltersForm');
        const searchParams = this._createSearchParams(form);
        if (searchParams === null) return;
        this._renderPage(searchParams);
        if(this.isDesktop) document.getElementById('FormSelectFilter')?.blur();
      }
      
      this.t = setTimeout(() => {
        func();
      }, wait);
    },
    rangePrice(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      priceInput = el.querySelectorAll(".price-input"),
      pricePreview = el.querySelectorAll(".price-preview"),
      range = el.querySelector(".slider .progress");
      let priceGap = 1;

      rangeInput.forEach((input) => {
        input.addEventListener("input", (e) => {
          e.preventDefault();
          let minVal = Number(rangeInput[0].value).toFixed(2),
            maxVal = Number(rangeInput[1].value).toFixed(2);;
          
          if (maxVal - minVal < priceGap) {
            if (e.target.className === "range-min") {
              rangeInput[0].value = maxVal - priceGap;
              priceInput[0].value = maxVal - priceGap;
            } else {
              rangeInput[1].value = minVal + priceGap;
              priceInput[1].value = maxVal + priceGap;
            }
          } else {
            priceInput[0].value = minVal;
            priceInput[1].value = maxVal;
            range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
            range.style.setProperty('--right_range', 100 - (maxVal / rangeInput[1].max) * 100 + '%');
          }
          pricePreview[0].textContent = minVal;
          pricePreview[1].textContent = maxVal;
        });
      });
    },
    initRange(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      range = el.querySelector(".slider .progress");
      
      let minVal = Number(rangeInput[0].value).toFixed(2),
      maxVal = Number(rangeInput[1].value).toFixed(2);;
      range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
      range.style.setProperty('--right_range',100 - (maxVal / rangeInput[1].max) * 100 + '%');
    },
    _reloadFilter(url) {
      const searchParams = url.indexOf('?') == -1 ? '' : url.slice(url.indexOf('?') + 1);
      return this._renderPage(searchParams);
    },
    _createSearchParams(form) {
      if (!(form instanceof HTMLFormElement)) return null;
      const formData = new FormData(form);
      const sortControl = Array.from(form.elements).find((element) => {
        return element.name === 'sort_by' && !element.disabled;
      });
      formData.delete('sort_by');
      if (sortControl?.value) formData.set('sort_by', sortControl.value);
      return new URLSearchParams(formData).toString();
    },
    _updateURLHash(searchParams) {
      const nextURL = `${window.location.pathname}${searchParams ? '?'.concat(searchParams) : ''}`;
      if (`${window.location.pathname}${window.location.search}` !== nextURL) {
        history.pushState({ searchParams }, '', nextURL);
      }
    },
    async _renderPage(searchParams, updateURLHash = true) {
      if (searchParams === null) return false;
      const serial = ++this.renderSerial;
      this.renderController?.abort();
      this.renderController = null;
      this.loading = true;
      this.renderStatus = 'Updating products.';

      try {
        let html = this.cachedResults[searchParams];
        if (!html) {
          const controller = new AbortController();
          this.renderController = controller;
          const suffix = searchParams ? `&${searchParams}` : '';
          const response = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}${suffix}`, {
            signal: controller.signal
          });
          if (!response.ok) throw new Error(`Facet request failed with status ${response.status}`);
          html = await response.text();
          if (serial !== this.renderSerial) return false;
          this.cachedResults[searchParams] = html;
        }
        if (serial !== this.renderSerial) return false;

        this._renderResults(html);
        this.searchParamsPrev = searchParams;
        if (updateURLHash) this._updateURLHash(searchParams);
        this.renderStatus = 'Products updated.';
        document.dispatchEvent(new CustomEvent("eurus:collection:reloaded"));
        return true;
      } catch (error) {
        if (error.name === 'AbortError' || serial !== this.renderSerial) return false;
        this.renderStatus = 'Products could not be updated. Please try again.';
        document.dispatchEvent(new CustomEvent("eurus:collection:reload-error"));
        return false;
      } finally {
        if (serial === this.renderSerial) {
          this.loading = false;
          this.renderController = null;
        }
      }
    },
    _renderResults(html) {
      const activeElement = document.activeElement;
      const activeId = activeElement?.id;
      const activeName = activeElement?.getAttribute?.('name');
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      this._renderFilters(parsedHTML);
      this._renderProductGridContainer(parsedHTML);
      this._renderProductCount(parsedHTML);
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          const replacement = activeId
            ? document.getElementById(activeId)
            : activeName
              ? document.getElementsByName(activeName)[0]
              : null;
          if (replacement?.getClientRects().length) replacement.focus({ preventScroll: true });
          if (this.show) this._filterFocus();
        });
      });
    },
    _renderFilters(parsedHTML) {
      let blockFiltesDrawer = '.form-drawer';
      let blockFiltesAside = '.form-aside';
      const selectBlockFiltesDrawer = document.querySelector(blockFiltesDrawer);
      const selectBlockFiltesAside = document.querySelector(blockFiltesAside);
      const activeTags = document.querySelectorAll("[data-active-filter-tag]");
      const parsedActiveTags = parsedHTML.querySelectorAll("[data-active-filter-tag]");
      const openFilterIndex = this.$el?.closest?.('.js-filter')?.dataset.index;

      if (openFilterIndex) {
        parsedHTML.querySelectorAll('.js-filter').forEach((filter) => {
          if (filter.dataset.index === openFilterIndex) filter.setAttribute('x-data', '{open: true}');
        });
      }

      activeTags.forEach((activeTag, index) => {
        const parsedActiveTag = parsedActiveTags[index] || parsedActiveTags[0];
        if (parsedActiveTag) activeTag.innerHTML = parsedActiveTag.innerHTML;
      });
      if (selectBlockFiltesDrawer) {
        const parsedDrawer = parsedHTML.querySelector(blockFiltesDrawer);
        if (parsedDrawer) selectBlockFiltesDrawer.innerHTML = parsedDrawer.innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      if (selectBlockFiltesAside) {
        const parsedAside = parsedHTML.querySelector(blockFiltesAside);
        if (parsedAside) selectBlockFiltesAside.innerHTML = parsedAside.innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      this._renderAdvancedFilters(parsedHTML);
    },
    _renderAdvancedFilters(html) {
      const destination = document.querySelectorAll(".filter-advanced");
      const source = html.querySelectorAll('.filter-advanced');

      if (source.length > 0 && destination.length > 0) {
        destination.forEach((destination, index) => {
          if (source[index]) destination.innerHTML = source[index].innerHTML;
        })
      }
    },
    _renderProductGridContainer(parsedHTML) {
      const destination = document.getElementById('ProductGridContainer');
      const source = parsedHTML.getElementById('ProductGridContainer');
      if (destination && source) destination.innerHTML = source.innerHTML;
    },
    _renderProductCount(parsedHTML) {
      const productCountEl = parsedHTML.getElementById('ProductCount');
      if (productCountEl) {
        const count = productCountEl.innerHTML;
        const container = document.getElementById('ProductCount_header');
        if (container) container.innerHTML = count;
        document.querySelectorAll('#ProductCountDrawer').forEach((drawerCount) => {
          drawerCount.innerHTML = count;
        });
        container?.classList.remove('loading');
      }
    },
    _renderAdditionalElements(html) {
      const container = document.getElementById('ProductPerPage');
      const source = html.getElementById('ProductPerPage');
      if (container && source) container.innerHTML = source.innerHTML;
    },
    _filterFocus() {
      if (this.show) Alpine.store('xFocusElement').trapFocus('ProductFilter','CloseFilter');
    },
    _filterRemoveFocus() {
      Alpine.store('xFocusElement').removeTrapFocus(this.filterOpener);
    },
    setFilterHeaderHeight() {
      const filterHeader = document.getElementById("FacetsWrapperDesktop");
      if (filterHeader) document.documentElement.style.setProperty('--height-sticky-filter', filterHeader.offsetHeight + "px");
    },
    setPositionOptionFilter(el) {
      const elRect = el.getBoundingClientRect();
      const elPopup = el.getElementsByClassName('popup-above')[0];
      let spacingRight = window.xViewport.innerWidth - elRect.left;
      let checkSpacing = spacingRight - el.innerWidth;
      if (checkSpacing >= 0) {
        elPopup.style.left = '0px';
      } else {
        elPopup.style.left = checkSpacing+ 'px';
      }
    },
    getPopupPosition(el) {
      this.$nextTick(() => {
        const elPopup = el.getElementsByClassName('popup-above')[0];
        if (elPopup) {
          const popupRect = elPopup.getBoundingClientRect();
          if( popupRect.right > window.xViewport.innerWidth){
            elPopup.style.right = 0;
          }
        }
      });
    }
  }));
});
